import * as Sentry from '@sentry/react';
import { BrowserOptions } from '@sentry/react';

export const sentryConfig: BrowserOptions = {
  dsn: import.meta.env['VITE_SENTRY_DSN'] as string,
  release: import.meta.env['VITE_APP_VERSION'] as string,
  debug: import.meta.env['VITE_SENTRY_DEBUG'] === 'true',
  environment: import.meta.env['VITE_SENTRY_ENV'] || 'production',
  tracesSampleRate: parseFloat(
    import.meta.env['VITE_SENTRY_TRACES_SAMPLE_RATE'] || '0.1',
  ),
  replaysSessionSampleRate: parseFloat(
    import.meta.env['VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE'] || '0.1',
  ),
  replaysOnErrorSampleRate: parseFloat(
    import.meta.env['VITE_SENTRY_REPLAYS_ERROR_SAMPLE_RATE'] || '1.0',
  ),
  profilesSampleRate: parseFloat(
    import.meta.env['VITE_SENTRY_PROFILES_SAMPLE_RATE'] || '0.1',
  ),
  maxBreadcrumbs: parseInt(
    import.meta.env['VITE_SENTRY_MAX_BREADCRUMBS'] || '100',
  ),
  maxValueLength: parseInt(
    import.meta.env['VITE_SENTRY_MAX_VALUE_LENGTH'] || '1000',
  ),
  normalizeDepth: parseInt(
    import.meta.env['VITE_SENTRY_NORMALIZE_DEPTH'] || '5',
  ),
  sendDefaultPii: import.meta.env['VITE_SENTRY_SEND_DEFAULT_PII'] === 'true',
  tracePropagationTargets: [
    new URL(import.meta.env['VITE_API_URL'] || 'http://localhost:8080')
      .hostname,
  ],
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
};

export const apiConfig = {
  url: import.meta.env['VITE_API_URL'] || 'http://localhost:8080',
  inMem: import.meta.env['VITE_API_IN_MEM'] === 'true',
};
